<template>
  <div>
    <!--img src="../assets/logo.png"-->
    <h1>{{ $t("errors.text404") }}</h1>
    <!-- {{ $t("frontendTestBBB.message") }}
    <Brouillon/> -->
  </div>
</template>

<script>
//import Brouillon from "@/components/Brouillon"

export default {
  name: "Test",
  components: {
    //Brouillon,
  },
}
</script>

<style lang="scss">

</style>
